import { PurchaseEligibility } from 'app/api/@generated/backend';

import { api } from 'app/api/common';

class PurchaseEligibilityService {
    public static readonly getPurchaseEligibility = async (
        partnerId: string,
        billingAccountId: string,
        servicePointId: string,
    ): Promise<PurchaseEligibility> =>
        api.customerController.getCustomerPurchaseEligibility(partnerId, billingAccountId, {
            servicePointId,
        });
}

export { PurchaseEligibilityService };
